import { TableCell } from '@/components/ui/table';
import { Data } from '@/domain/controlling/entities/historie';
import {
  AbsoluteNumberField,
  AbweichungIcon,
} from '@/domain/controlling/pages/Umsatzplanung/components';
import { useTranslation } from 'react-i18next';

export function AbsatzCell({
  tagebuchData,
}: {
  tagebuchData: Data | undefined;
}) {
  const { t } = useTranslation();

  return (
    <TableCell className="font-medium py-4 ps-4">
      <div className="flex gap-2 items-center">
        <AbsoluteNumberField
          value={tagebuchData?.istAbsatz?.wert}
          unit={t('domain.controlling.umsatzplanung.units.stueck')}
        />
        {tagebuchData?.planAbsatz?.wert !== undefined && (
          <AbweichungIcon
            baseValue={tagebuchData?.istAbsatz?.wert}
            comparisonValue={tagebuchData?.planAbsatz?.wert}
          />
        )}
      </div>
    </TableCell>
  );
}
